module.exports = __webpack_public_path__ + "img/P49-en.61ad336c.png";